import { Component } from '@angular/core';

@Component({
  selector: 'app-collegues',
  standalone: true,
  imports: [],
  templateUrl: './collegues.component.html',
  styleUrl: './collegues.component.scss'
})
export class ColleguesComponent {

}
